export function NewsletterMatchRows({ matches, labels }) {
  if (!matches?.length) return null;
  return (
    <section className="pingflo-section">
      <h2>{labels.title}</h2>
      <ul className="pingflo-matches">
        {matches.map((match) => (
          <li key={match.fixture_id || `${match.date}-${match.home_name}`}>
            <span className="pingflo-name">
              {match.home_name}
              <b>
                {match.home_score}–{match.away_score}
              </b>
              {match.away_name}
            </span>
            <span className={`pingflo-outcome is-${match.outcome}`}>
              {labels.outcome(match.outcome)}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
